"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetAPISellerSSMConfigDefaultValue = void 0;
exports.TargetAPISellerSSMConfigDefaultValue = {
    disabled_users: [],
    enabled_users: [],
    enabled_segments: [],
    excluded_services: [],
    function_url_services: [],
};
//# sourceMappingURL=TargetAPISellerSSMConfig.js.map